import { Tooltip, TableCell, Typography, Stack, Box } from '@mui/material';

interface RoleTableCellProps {
  roles: string[];
}

function RoleTableCell({ roles }: RoleTableCellProps) {
  const [firstRole, ...restRoles] = roles;
  const hasMore = restRoles.length > 0;

  return (
    <TableCell>
      <Tooltip
        disableHoverListener={!hasMore}
        title={
          hasMore && (
            <Stack direction="row" gap={0.5}>
              {roles.map((role, index) => (
                <Typography key={role} variant="caption">
                  {role}
                  {index < roles.length - 1 && ', '}
                </Typography>
              ))}
            </Stack>
          )
        }>
        <Box display="inline-flex" alignItems="center">
          <Typography variant="body2">{firstRole}</Typography>
          {hasMore && (
            <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
              + ...
            </Typography>
          )}
        </Box>
      </Tooltip>
    </TableCell>
  );
}

export default RoleTableCell;
